import { FC } from "react"
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Autoplay, Pagination } from "swiper/modules"

const CompletedProjects: FC = () =>
  <div className='container-fluid completed-projects' id='completed-projects'>
    <div className="row completed-projects__title">
      <h1>Выполненные проекты</h1>
    </div>
    <div className="row completed-projects__slider">
      <Swiper
        pagination={{clickable: true}}
        modules={[Pagination, Autoplay]}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          slidesPerView: 2
        }}
        className="mySwiper"
      >
        <SwiperSlide>
          <img src={`${process.env.REACT_APP_DJANGO_DOMEN}/images/CompletedProjects/1.jpg`} alt="" />
          <img src={`${process.env.REACT_APP_DJANGO_DOMEN}/images/CompletedProjects/2.jpg`} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={`${process.env.REACT_APP_DJANGO_DOMEN}/images/CompletedProjects/3.jpg`} alt="" />
          <img src={`${process.env.REACT_APP_DJANGO_DOMEN}/images/CompletedProjects/4.jpg`} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={`${process.env.REACT_APP_DJANGO_DOMEN}/images/CompletedProjects/5.jpg`} alt="" />
          <img src={`${process.env.REACT_APP_DJANGO_DOMEN}/images/CompletedProjects/6.jpg`} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={`${process.env.REACT_APP_DJANGO_DOMEN}/images/CompletedProjects/7.jpg`} alt="" />
          <img src={`${process.env.REACT_APP_DJANGO_DOMEN}/images/CompletedProjects/8.jpg`} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={`${process.env.REACT_APP_DJANGO_DOMEN}/images/CompletedProjects/9.jpg`} alt="" />
          <img src={`${process.env.REACT_APP_DJANGO_DOMEN}/images/CompletedProjects/10.jpg`} alt="" />
        </SwiperSlide>
      </Swiper>
    </div>
  </div>

export default CompletedProjects;
